<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 85.348 85.348"
		xml:space="preserve"
		fill="currentColor"
	>
		<path
			d="M77.45,57.691v-3.16V35.563V16.595c0-1.736-1.421-3.16-3.16-3.16H11.066 c-1.739,0-3.167,1.417-3.167,3.16v18.968v18.968v3.16L0,67.175c0,2.613,2.122,4.738,4.738,4.738H80.61 c2.613,0,4.738-2.126,4.738-4.738L77.45,57.691z M49.002,70.339H36.358c-0.437,0-0.791-0.351-0.791-0.791s0.354-0.791,0.791-0.791 h12.644c0.437,0,0.791,0.351,0.791,0.791C49.785,69.988,49.438,70.339,49.002,70.339z M29.644,67.179l2.412-2.895h21.233 l2.416,2.895H29.644z M73.001,52.101c0,1.525-1.242,2.759-2.759,2.759H15.106c-1.514,0-2.756-1.245-2.756-2.759V19.032 c0-1.525,1.242-2.759,2.756-2.759h19.87l11.227,5.834L31.455,38.057l18.478,14.169l-7.695-19.354l12.816-6.166L51.07,16.269h19.172 c1.517,0,2.759,1.242,2.759,2.759V52.101L73.001,52.101z"
		></path>
	</svg>
</div>
